import { useState } from 'react';

const steps = ['Offer Details', 'Traffic Source', 'Campaign', 'Overview', 'Success'];

export function useWizardSteps() {
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const reset = () => {
    setActiveStep(0);
  };

  const isFirstStep = activeStep === 0;
  const isLastStep = activeStep === steps.length - 1;

  return {
    activeStep,
    steps,
    handleNext,
    handleBack,
    reset,
    isFirstStep,
    isLastStep,
  };
}

